import { profile } from "@/mocks/profile";

export default function ProfileSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-64 h-64 md:w-80 md:h-80 flex-shrink-0 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20portrait%20with%20gentle%20smile%2C%20natural%20makeup%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20elegant%20casual%20outfit%2C%20professional%20headshot%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition&width=800&height=800&seq=profile-portrait&orientation=squarish"
              alt="苍井樱个人写真"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
              {profile.name}{" "}
              <span className="text-base text-foreground-500 font-normal">
                {profile.nameJa}
              </span>
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
              {profile.bio}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
              {[
                { label: "生日", value: profile.birthday },
                { label: "出身地", value: profile.birthplace },
                { label: "身高", value: profile.height },
                { label: "血型", value: profile.bloodType },
                { label: "三围", value: profile.measurements },
                { label: "爱好", value: profile.hobby },
                { label: "出道", value: profile.debut },
                { label: "事务所", value: profile.agency },
              ].map((item) => (
                <div
                  key={item.label}
                  className="bg-background-100 rounded-xl p-3 text-center"
                >
                  <p className="text-xs text-foreground-500 mb-1">{item.label}</p>
                  <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <a
                href={profile.socialLinks.twitter}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
              <a
                href={profile.socialLinks.instagram}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href={profile.socialLinks.youtube}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}